import { useMemo, useState } from "react";

import { type Paragrafo } from "../paragrafi";


interface Props
{
    paragrafi: Paragrafo[];
    chiudi: () => void;
    vai: (p: Paragrafo) => void;
}


export function Paragrafi({ paragrafi, chiudi, vai }: Props): React.JSX.Element
{
    const [filtro, setFiltro] = useState("");

    const mostrati = useMemo(() =>
    {
        const q = filtro.trim().toLowerCase();
        if (q === "") { return paragrafi; }
        return paragrafi.filter((p) => p.id.toLowerCase().includes(q) || p.titolo.toLowerCase().includes(q));
    }, [paragrafi, filtro]);

    // Un id ripetuto e' un errore che md2pdf scopre solo in fase di
    // composizione: qui si vede mentre lo si scrive.
    const doppi = useMemo(() =>
    {
        const conto = new Map<string, number>();
        for (const p of paragrafi) { conto.set(p.id, (conto.get(p.id) ?? 0) + 1); }
        return new Set([...conto].filter(([, n]) => n > 1).map(([id]) => id));
    }, [paragrafi]);

    return (
        <div className="velo" onMouseDown={(e) => { if (e.target === e.currentTarget) { chiudi(); } }}>
            <div className="finestra" role="dialog" aria-label="Paragrafi registrati">
                <h2>Paragrafi</h2>
                <p className="fioco">
                    {paragrafi.length} identificatori §: sono quelli che puoi citare con
                    <code> §id:chapter-page</code>. Clicca per andarci.
                </p>

                <input
                    autoFocus
                    aria-label="filtro paragrafi"
                    placeholder="filtra per id o titolo…"
                    value={filtro}
                    onChange={(e) => setFiltro(e.target.value)}
                />

                <ul className="paragrafi">
                    {mostrati.map((p) => (
                        <li key={`${p.id}-${p.riga}`}>
                            <button type="button" onClick={() => vai(p)}>
                                <span className="livello">{"·".repeat(p.livello - 1)}</span>
                                <span className="titolo">{p.titolo}</span>
                                <code className={doppi.has(p.id) ? "id doppio" : "id"}>§{p.id}</code>
                                <span className="fioco riga">riga {p.riga}</span>
                            </button>
                        </li>
                    ))}
                    {mostrati.length === 0 && (
                        <p className="fioco">
                            {paragrafi.length === 0
                                ? "Nessun paragrafo registrato: aggiungi §id in fondo a un titolo."
                                : "Nessun paragrafo corrisponde al filtro."}
                        </p>
                    )}
                </ul>

                {doppi.size > 0 && (
                    <p className="allarme">
                        Identificatori usati più di una volta: {[...doppi].map((i) => `§${i}`).join(", ")} —
                        md2pdf rifiuterà la citazione come ambigua.
                    </p>
                )}

                <div className="azioni">
                    <span className="spazio" />
                    <button type="button" onClick={chiudi}>Chiudi</button>
                </div>
            </div>
        </div>
    );
}
